// 导入封装好的axios实例
import request from './request'
import { encryptResult } from '@/http/commonEncry.js'

const http = {
    
        /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get_noec(url,params){
        const config = {
            method: 'get',
            url:url
        }

        if(params) config.params = params 
        return request(config)
    },
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url,funcname,params){
        const config = {
            method: 'post',
            url:url
        }
        if(params) config.data =  encryptResult(funcname,params)
        config.mode = "json" 
        return request(config)
    },
    post(url,funcname,params){
        const config = {
            method: 'post',
            url:url
        }
        if(params) config.data =  encryptResult(funcname,params)
        config.mode = "json" 
        return request(config)
    },
    post_form(url,funcname,params){
        const config = {
            method: 'post',
            url:url
        }
        if(params)  config.data =  encryptResult(funcname,params)
        config.mode = "form"
        return request(config)
    },
    put(url,funcname,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params =  encryptResult(funcname,params)
        return request(config)
    },
    delete(url,funcname,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params =  encryptResult(funcname,params)
        return request(config)
    }
}
 
//导出
export default http